/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Otp scope
 */
export type ObtainOtpRequestScope = typeof ObtainOtpRequestScope[keyof typeof ObtainOtpRequestScope];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ObtainOtpRequestScope = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  DIGITAL_WITHDRAWAL: 'DIGITAL_WITHDRAWAL',
  FIAT_WITHDRAWAL: 'FIAT_WITHDRAWAL',
  FIAT_DEPOSIT: 'FIAT_DEPOSIT',
  BILL_PAYMENT: 'BILL_PAYMENT',
  ADD_DIGITAL_ADDRESS: 'ADD_DIGITAL_ADDRESS',
  LOGIN: 'LOGIN',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  ENABLE_2FA: 'ENABLE_2FA',
  CHANGE_EMAIL_ADDRESS: 'CHANGE_EMAIL_ADDRESS',
  ADD_PHONE_NUMBER: 'ADD_PHONE_NUMBER',
  CHANGE_PHONE_NUMBER: 'CHANGE_PHONE_NUMBER',
  P2P_TRANSFER: 'P2P_TRANSFER',
  CARD_ACTIVATION: 'CARD_ACTIVATION',
  CARD_ATM_PIN_CHANGE: 'CARD_ATM_PIN_CHANGE',
  ADD_ANTI_PHISHING_CODE: 'ADD_ANTI_PHISHING_CODE',
  UPDATE_ANTI_PHISHING_CODE: 'UPDATE_ANTI_PHISHING_CODE',
  FIAT_INSTRUCTION: 'FIAT_INSTRUCTION',
  INSTRUCTION: 'INSTRUCTION',
  ACCESS_CARD_OTP: 'ACCESS_CARD_OTP',
  CHANGE_BENEFICIARIES: 'CHANGE_BENEFICIARIES',
  ENABLE_GOOGLE_AUTHENTICATION: 'ENABLE_GOOGLE_AUTHENTICATION',
  SCAN_TO_PAY: 'SCAN_TO_PAY',
  SEND_TRANSACTION: 'SEND_TRANSACTION',
} as const;
